import React from "react";
import { Routes, Route } from "react-router-dom";
import AdminPage from "../pages/Admin/AdminPage/AdminPage";
import UserManagement from "../pages/Admin/UserManagement/UserManagement";
import CompanyList from "../pages/Admin/CompanyList/CompanyList";
import CompanyForm from "../pages/Admin/CompanyForm/CompanyForm";
import CompanyDetail from "../pages/Admin/CompanyDetail/CompanyDetail";
import RelatedVideoIntro from "../pages/Admin/RelatedVideoIntro";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminPage />}>
        <Route path="users" element={<UserManagement />} />
        <Route path="companies" element={<CompanyList />} />
        <Route path="companies/add" element={<CompanyForm />} />
        <Route path="companies/:companyId" element={<CompanyDetail />} />
        <Route path="related-videos" element={<RelatedVideoIntro />} />
        {/* 
        <Route path="companies" element={<CompanyRegistration />} />
        <Route path="news" element={<NewsManagement />} />
        
        <Route path="stock-price" element={<StockPriceManagement />} />
        <Route path="market-sketch" element={<MarketSketchManagement />} />
        <Route path="library" element={<LibraryManagement />} /> */}
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
